import React, { FunctionComponent } from 'react';
import { pathOr } from 'ramda';
import { useQuery } from 'react-apollo';
import withStyles from 'react-jss';
import { Header, Image } from 'semantic-ui-react';

import { GET_MERCHANT } from 'components/Header/components/SecondaryNav/SecondaryNav.queries';
import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';
import Query from 'components/Query';
import { BrandAsset } from 'scenes/Home/components/MerchantCard/MerchantCard.helper';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

type Merchant = {
  merchantId: string;
  merchantName: string;
  logo: string;
  brandAssets: BrandAsset;
};

const styles = {
  merchantName: {
    fontSize: '1.25rem !important',
    margin: '0 !important',
    paddingLeft: '1rem !important',
  },
};

export type QueryResponse = {
  loading: boolean;
  data: {
    merchantList: {
      result: Merchant[];
    };
  };
};

const renderMerchantLogo = (classes: Styles) => (response: QueryResponse) => {
  const { loading, data } = response;

  if (loading) return null;

  const [{ merchantName, brandAssets }] = pathOr(
    [],
    ['merchantList', 'result'],
    data,
  ) as Merchant[];

  const merchantLogo = pathOr('', ['image', 'icon', 'path'], brandAssets);

  return (
    <>
      <Image size="tiny" src={merchantLogo} />
      <Header as="h2" className={classes.merchantName}>
        {merchantName}
      </Header>
    </>
  );
};

const MerchantLogo: FunctionComponent<Props> = ({ classes }) => {
  const { loading, data } = useQuery(GET_PROFILE);

  if (loading) return null;

  const { userProfile } = data;
  const { merchantId } = userProfile;
  return (
    <Query
      enableProgressInfo
      query={GET_MERCHANT}
      render={renderMerchantLogo(classes)}
      variables={{
        params: {
          merchantId,
        },
        package: 'DEFAULT_BRANDING',
      }}
    />
  );
};

export default withStyles(styles)(MerchantLogo);
